import { render, staticRenderFns } from "./SoftwareEdit.vue?vue&type=template&id=f2da6c66"
import script from "./SoftwareEdit.vue?vue&type=script&lang=js"
export * from "./SoftwareEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports